var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lserv-tooltip',{attrs:{"text":_vm.tooltip,"disabled":!_vm.tooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"v-btn",attrs:{"icon":"","color":_vm.color},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',attrs,false),on),[_c('lserv-icon',{attrs:{"name":_vm.icon}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }